"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TextInput = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _coreBaseProps = require("@vfuk/core-base-props");

var _coreIcon = _interopRequireDefault(require("@vfuk/core-icon"));

var _coreHelpers = require("@vfuk/core-helpers");

var Styled = _interopRequireWildcard(require("./styles/TextInput.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var TextInput = /*#__PURE__*/function (_PureComponent) {
  _inherits(TextInput, _PureComponent);

  var _super = _createSuper(TextInput);

  function TextInput() {
    var _this;

    _classCallCheck(this, TextInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.handleOnChange = function (event) {
      // eslint-disable-next-line sonarjs/no-collapsible-if
      if (_this.props.type === 'number' && event.target.value) {
        if (!(0, _coreHelpers.isNumber)(event.target.value)) return;
      }

      if (_this.props.state !== 'disabled') {
        if (_this.props.beforeChange) {
          event.target.value = _this.props.beforeChange(event.target.value);
        }

        _this.props.onChange(event);
      }
    };

    _this.handleOnBlur = function (event) {
      if (_this.props.state !== 'disabled' && _this.props.onBlur) {
        _this.props.onBlur(event);
      }
    };

    _this.handleOnKeyDown = function (event) {
      if (_this.props.state !== 'disabled' && _this.props.onKeyDown) {
        _this.props.onKeyDown(event);
      }
    };

    _this.componentName = 'TextInput';
    return _this;
  }

  _createClass(TextInput, [{
    key: "typeSpecificProps",
    get: function get() {
      if (this.props.type === 'number') {
        return {
          type: 'text',
          inputMode: 'numeric',
          pattern: '[0-9]*'
        };
      }

      return {
        type: this.props.type
      };
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(Styled.TextInputWrapper, _extends({}, this.props.dataAttributes, {
        id: "".concat(this.props.id, "-text-input"),
        "data-component-name": this.componentName,
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix)
      }), /*#__PURE__*/_react["default"].createElement(Styled.TextInput, _extends({
        id: this.props.id,
        name: this.props.name || this.props.id,
        value: this.props.value,
        placeholder: this.props.placeholder,
        required: this.props.required,
        ref: this.props.domRef,
        autoComplete: this.props.autoComplete,
        onChange: this.handleOnChange,
        onBlur: this.handleOnBlur,
        onClick: this.props.onClick,
        "aria-disabled": this.props.state === 'disabled',
        "aria-invalid": this.props.state === 'error',
        "aria-describedby": this.props.describedBy,
        minLength: this.props.minLength,
        maxLength: this.props.maxLength,
        onKeyDown: this.handleOnKeyDown,
        state: this.props.state,
        readOnly: this.props.state === 'disabled',
        spellCheck: this.props.spellcheck,
        pattern: this.props.pattern,
        autoCapitalize: this.props.autoCapitalize
      }, this.typeSpecificProps, this.props.dataAttributes, {
        "data-selector": (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'input')
      })), this.props.infieldIcon && /*#__PURE__*/_react["default"].createElement(Styled.IconWrapper, null, /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], {
        name: this.props.infieldIcon,
        appearance: this.props.theme.formFields.icon.appearance,
        inverse: this.props.theme.formFields.icon.inverse,
        size: 3,
        dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(this.props.dataSelectorPrefix, 'icon')
      })));
    }
  }]);

  return TextInput;
}(_react.PureComponent);

exports.TextInput = TextInput;
TextInput.defaultProps = {
  autoComplete: 'on',
  type: 'text'
};
TextInput.displayName = "TextInput";

var _default = (0, _styledComponents.withTheme)(TextInput);

exports["default"] = _default;
//# sourceMappingURL=TextInput.js.map